import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CAResult } from '../models/ExternalAudits/ca-result';
import { environment } from 'src/environments/environment';

import { BasicResult } from '../models/basic-result';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExternalAuditsService {

  constructor(private httpClient: HttpClient) { }


  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    observe: 'response' as 'response',
    responseType: 'json' as const,
    withCredentials: true,
  };

  getExternalAudit(key: string,sharedLink:boolean): Observable<CAResult> {
    var req = JSON.stringify({Key:key, SharedLink:sharedLink});
    return this.httpClient.post<CAResult>(`${environment.apiUrl}customerform/getform`, req, this.httpOptions).pipe(
      map((res:any) => {
        return new CAResult(res.body!);
      })
    );
  }
  saveExternalAudit(auditResult: CAResult): Observable<BasicResult> {
    var req = JSON.stringify(auditResult);
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}customerform/submitform`, auditResult, this.httpOptions).pipe(
      map((res:any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  cancelSubscription(guid: string) {
    var req = JSON.stringify(guid);
    return this.httpClient.post<string>(`${environment.apiUrl}customerform/optout`, req, this.httpOptions).pipe(
    );
  }
}
